import transactionsApi from '../_api'
import companyApi from '@/modules/company/_api/'
import i18n from '@/locales/'
import { isEqual } from 'lodash-es'
import { segmentTrack } from '@/analytics/segment'
import { serialize } from '@/utils/utils'
import { REVIEW_STATUS } from '@/constants/reviewStatus'
import { MEDIA_TYPE } from '../_constants/MediaType'

export default {
  setCurrentTransaction: ({ commit }, transaction) => {
    commit('setCurrentTransaction', transaction)
  },
  fetchTransactions: async (
    { getters, commit, dispatch },
    pagination = true
  ) => {
    try {
      const page = getters.currentPage
      let filters = Object.assign({}, getters.filters)
      if (filters['accountingPeriodId']) {
        delete filters['accountingPeriodId']
      }
      if (filters.budget) {
        delete filters.budget
      }
      if (filters.users) {
        delete filters.users
      }
      if (page === 1) {
        commit('setLoadingTransactions', true)
      } else {
        commit('setLoadingNextPageTransactions', true)
      }
      let response
      response = await transactionsApi.getTransactions(
        page,
        pagination,
        filters
      )
      const lastPage = response.headers['pagination-last-page']
      commit('setTransactionsLastPage', lastPage)
      commit('setTransactions', response.data)
      commit(
        'setTransactionsTotalItems',
        Number.parseInt(response.headers['pagination-total-items'])
      )
      commit('setLoadingTransactions', false)
      commit('setLoadingNextPageTransactions', false)
    } catch (error) {
      if (('cancel' in error)) {
        dispatch(
          'SnackBars/addErrorHandler',
          { error: error, errorMessage: 'transactions_fetch_transactions_error' },
          { root: true }
        )
        commit('setLoadingTransactions', false)
        commit('setLoadingNextPageTransactions', false)
      }
    }
  },
  fetchTransactionsWithoutFilters: async (
    { getters, commit, dispatch },
    filters
  ) => {
    try {
      const page = getters.currentPage
      if (page === 1) {
        commit('setLoadingTransactions', true)
      } else {
        commit('setLoadingNextPageTransactions', true)
      }
      let response
      response = await transactionsApi.getTransactions(
        page,
        true,
        filters
      )
      const lastPage = response.headers['pagination-last-page']
      commit('setTransactionsLastPage', lastPage)
      commit('setTransactions', response.data)
      commit(
        'setTransactionsTotalItems',
        Number.parseInt(response.headers['pagination-total-items'])
      )
      commit('setLoadingTransactions', false)
      commit('setLoadingNextPageTransactions', false)
    } catch (error) {
      if (('cancel' in error)) {
        dispatch(
          'SnackBars/addErrorHandler',
          { error: error, errorMessage: 'transactions_fetch_transactions_error' },
          { root: true }
        )
        commit('setLoadingTransactions', false)
        commit('setLoadingNextPageTransactions', false)
      }
    }
  },
  fetchUserReimbursements: async (
    { getters, commit, dispatch },
    pagination = true
  ) => {
    try {
      const page = getters.usersCurrentPage
      let filters = Object.assign({}, getters.filters)
      if (filters['accountingPeriodId']) {
        delete filters['accountingPeriodId']
      }
      if (filters.budget) {
        delete filters.budget
      }
      if (filters.users) {
        delete filters.users
      }
      if (page === 1) {
        commit('setLoadingTransactions', true)
      } else {
        commit('setLoadingNextPageTransactions', true)
      }

      let response
      response = await transactionsApi.getUserReimbursements(
        page,
        pagination,
        filters
      )
      const lastPage = Number.parseInt(response.headers['pagination-last-page'])
      commit('setUsersLastPage', lastPage)
      commit('setUsers', response.data)
      commit(
        'setUsersTotalItems',
        Number.parseInt(response.headers['pagination-total-items'])
      )
      if (getters.selectedUsersBulkAction) {
        dispatch('setAllUsersAsSelected')
      }
      commit('setLoadingTransactions', false)
      commit('setLoadingNextPageTransactions', false)
    } catch (error) {
      if (('cancel' in error)) {
        dispatch(
          'SnackBars/addErrorHandler',
          { error: error, errorMessage: 'transactions_fetch_transactions_error' },
          { root: true }
        )
        commit('setLoadingTransactions', false)
        commit('setLoadingNextPageTransactions', false)
      }
    }
  },
  nextUserReimbursementsPage: async ({ getters, commit, dispatch }) => {
    if (getters.isLoadingNextPageTransactions) return
    commit('incrementUsersCurrentPage')
    dispatch('fetchUserReimbursements')
  },
  fetchBudgetTransactions: async (
    { getters, commit, dispatch },
    pagination = true
  ) => {
    try {
      const page = getters.currentPage
      let filters = Object.assign({}, getters.filters)
      if (filters['accountingPeriodId']) {
        delete filters['accountingPeriodId']
      }
      if (page === 1) {
        commit('setLoadingTransactions', true)
      } else {
        commit('setLoadingNextPageTransactions', true)
      }
      let response
      response = await transactionsApi.getTransactionsByBudget(
        page,
        pagination,
        filters
      )
      const lastPage = response.headers['pagination-last-page']
      commit('setTransactionsLastPage', lastPage)
      commit('setTransactions', response.data)
      commit(
        'setTransactionsTotalItems',
        Number.parseInt(response.headers['pagination-total-items'])
      )
      if (getters.selectedTransactionsBulkAction) {
        dispatch('setAllTransactionsAsSelected')
      }
      commit('setLoadingTransactions', false)
      commit('setLoadingNextPageTransactions', false)
    } catch (error) {
      if (('cancel' in error)) {
        dispatch(
          'SnackBars/addErrorHandler',
          { error: error, errorMessage: 'transactions_fetch_transactions_error' },
          { root: true }
        )
        commit('setLoadingTransactions', false)
        commit('setLoadingNextPageTransactions', false)
      }
    }
  },
  fetchTransaction: async ({ commit, dispatch }, transactionId) => {
    try {
      const response = await transactionsApi.getTransaction(transactionId)
      commit('updateTransaction', { ...response.data })
      commit('setCurrentTransaction', response.data)
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        { error: error, errorMessage: 'transactions_fetch_transaction_error' },
        { root: true }
      )
    }
  },
  resetCurrentTransaction: ({ commit }) => {
    commit('setCurrentTransaction', {})
  },
  createTransaction: async (
    { commit, dispatch, rootState },
    transactionInformation
  ) => {
    try {
      const response = await transactionsApi.postExpense(transactionInformation)
      commit('setNewExpense', response.data.transaction.id)

      dispatch(
        'SnackBars/addSuccess',
        i18n.t('expense_create_expense_success'),
        { root: true }
      )
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        { error: error, errorMessage: 'expense_create_expense_error' },
        { root: true }
      )
    }
  },
  accountTransaction: async (
    { commit, dispatch },
    transactionId
  ) => {
    try {
      const response = await transactionsApi.accountTransaction(
        transactionId
      )
      commit('updateTransaction', response.data)
      commit('setCurrentTransaction', response.data)

      dispatch(
        'SnackBars/addSuccess',
        i18n.t('transaction_edit_transaccion_success'),
        { root: true }
      )
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        { error: error, errorMessage: 'transaction_put_transaction_error' },
        { root: true }
      )
    }
  },
  unaccountTransaction: async (
    { commit, dispatch },
    transactionId
  ) => {
    try {
      const response = await transactionsApi.unaccountTransaction(
        transactionId
      )
      commit('updateTransaction', response.data)
      commit('setCurrentTransaction', response.data)

      dispatch(
        'SnackBars/addSuccess',
        i18n.t('transaction_edit_transaccion_success'),
        { root: true }
      )
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        { error: error, errorMessage: 'transaction_put_transaction_error' },
        { root: true }
      )
    }
  },
  editTransaction: async (
    { getters, commit, dispatch, rootState },
    { transactionInformation, transactionTagUpdatedFlag, ignoreSuccessFlag = false, originalTransaction }
  ) => {
    try {
      // TODO: Dead code : Upload of receipts
      if (transactionInformation && transactionInformation.files) {
        await dispatch('submitTransactionReceipt', {
          id: transactionInformation.id,
          files: transactionInformation.files
        })
      }

      let transactionId = transactionInformation.id
      let transaction = { ...transactionInformation }
      delete transaction.id
      delete transaction.files
      const response = await transactionsApi.putTransaction(
        transactionId,
        transaction
      )
      commit('updateTransaction', response.data)
      commit('setCurrentTransaction', response.data)
      if (originalTransaction.isCompleted !== response.data.isCompleted) {
        await dispatch('fetchTransactionDashboard')
      }

      if (ignoreSuccessFlag) return
      dispatch(
        'SnackBars/addSuccess',
        i18n.t('transaction_edit_transaccion_success'),
        { root: true }
      )

      if (response.data.type.code === 'EXPENSE') return

      const transactionTags = response.data.transactionTags.map(
        el => el.tag.name
      )

      let transactionCategoryOrSubcategory = ''

      if (response.data.customCategory) {
        transactionCategoryOrSubcategory = response.data.customCategory.name
      } else {
        if (response.data.defaultCategory) {
          transactionCategoryOrSubcategory = response.data.defaultCategory.name
        }
      }

      const isNormalTransaction =
        originalTransaction.budget.type.code === 'NORMAL'

      if (isNormalTransaction) {
        segmentTrack('Transaction data added', {
          transaction_amount: response.data.amount,
          type_of_ticket: response.data.receipt.isBill ? 'invoice' : 'receipt',
          custom_field_added: transactionTags.join(','),
          notes_added:
            originalTransaction.notes !== response.data.notes
              ? response.data.notes
              : '',
          category_changed: transactionCategoryOrSubcategory,
          budget:
            originalTransaction.budget.id === response.data.budget.name
              ? ''
              : response.data.budget.name,
          completed_now: !!(
            !originalTransaction.isCompleted && response.data.isCompleted
          ),
          company_id: response.data.receipt.providerData,
          company_name: response.data.receipt.provider,
          custom_field_updated: transactionTagUpdatedFlag,
          is_same_user:
            rootState['LoginStore'].user.id === response.data.card.user.id,
          external_user:
            rootState['LoginStore'].user.id === response.data.card.user.id
              ? response.data.card.user.id
              : 0,
          is_completed: response.data.isCompleted
        })
      } else {
        segmentTrack('User recategorized benefit transaction', {
          new_budget: response.data.budget.name
        })
      }

      /*  AEAT  Receipt Data */
      /*
      const receipt = {
        taxBase1: 0,
        vatBase1: 0,
        taxBase2:0,
        vatBase2:0,
        taxBase3:0,
        vatBase3:0,
        taxBase4: 0,
        vatBase4: 0,
        totalReceipt: transactionInformation.amount,
        provider:transactionInformation.socialReason,

      } */
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        { error: error, errorMessage: 'transaction_put_transaction_error' },
        { root: true }
      )
    }
  },
  submitTransactionReceipt: async (
    { getters, commit, dispatch },
    transactionInformation
  ) => {
    try {
      if (
        transactionInformation &&
        transactionInformation.id &&
        transactionInformation.files &&
        (transactionInformation.type || (transactionInformation.types && transactionInformation.types.length > 0))
      ) {
        let index = 0
        let { dragAndDropUpload } = transactionInformation

        if (dragAndDropUpload) {
          commit('setReceiptUploadingByDragAndDrop', true)
        }
        for (const file of transactionInformation.files) {
          let receipt = new FormData()
          receipt.append('file', file)
          receipt.append('isBill', (transactionInformation.type || transactionInformation.types[index]) === MEDIA_TYPE.BILL)
          await transactionsApi.postTransactionMedia(
            transactionInformation.id,
            receipt
          )
          index++
        }
      } else {
        return
      }
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        {
          error: error,
          errorMessage: 'transactions_put_transaction_resource_error'
        },
        { root: true }
      )
      return 'error'
    } finally {
      commit('setReceiptUploadingByDragAndDrop', false)
    }
  },
  deleteTransaction: async ({ getters, commit, dispatch }, transactionId) => {
    try {
      await transactionsApi.deleteTransaction(transactionId)
      dispatch('fetchTransactionDashboard')
      commit('deleteTransaction', transactionId)

      dispatch(
        'SnackBars/addSuccess',
        i18n.t('transactions_remove_transaction_success'),
        { root: true }
      )
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        { error: error, errorMessage: 'transactions_remove_transaction_error' },
        { root: true }
      )
    }
  },
  changeTransactionReceiptType: async (
    { getters, commit, dispatch },
    information
  ) => {
    try {
      if (information.resourceId >= 0) {
        await transactionsApi.changeTransactionReceiptType(information.resourceId, { isBill: information.isBill })
      } else {
        return
      }
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        {
          error: error,
          errorMessage: 'transactions_put_transaction_resource_error'
        },
        { root: true }
      )
    }
  },
  deleteTransactionReceipt: async (
    { getters, commit, dispatch },
    receiptId
  ) => {
    try {
      if (receiptId >= 0) {
        await transactionsApi.deleteTransactionReceipt(receiptId)
      } else {
        return
      }
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        {
          error: error,
          errorMessage: 'transactions_put_transaction_resource_error'
        },
        { root: true }
      )
    }
  },
  sortTransactionsByField: (
    { dispatch, getters, commit },
    { fieldName, direction = 'TOGGLE' }
  ) => {
    const fields = Array.isArray(fieldName) ? fieldName : [fieldName]
    let newFilters = {}
    fields.forEach(el => {
      const order = `order[${el}]`
      if (direction === 'TOGGLE') {
        if (getters.filters[order] === 'ASC') {
          newFilters[order] = 'DESC'
        } else if (getters.filters[order] === 'DESC') {
          newFilters[order] = undefined
        } else {
          newFilters[order] = 'ASC'
        }
      }
    })
    Object.keys(getters.filters).forEach(item => {
      if (item.includes('order') && !item.includes(fieldName)) {
        getters.filters[item] = undefined
      }
    })
    dispatch('addTransactionsFilters', newFilters)
  },

  setTransactionsFilters: async (
    { commit, getters, dispatch },
    { filters, force = false, users = false, budget = false, mergeFilters = false }
  ) => {
    let order = 0
    Object.keys(filters).forEach(key => {
      if (key.includes('order[')) order++
    })
    if (order > 1) delete filters['order[id]']
    if (!isEqual(filters, getters.filters) || force) {
      if (mergeFilters) {
        commit('setTransactionsFilters', { ...getters.filters, ...filters })
      } else {
        commit('setTransactionsFilters', filters)
      }

      if (users) {
        await dispatch('fetchUserReimbursements')
      } else if (budget) {
        await dispatch('fetchBudgetTransactions')
      } else {
        await dispatch('fetchTransactions')
      }
      // if (getters.selectAllFlag) {
      //   /*dispatch('toggleSelectAll', false)*/
      // }
    }
  },
  addTransactionsFilters: ({ getters, dispatch }, newFilters) => {
    let mergeFilters = { ...getters.filters, ...newFilters }

    dispatch('removeUndefinedFilters', mergeFilters)
  },
  resetFilters: ({ dispatch }) => {
    dispatch('FiltersStore/TransactionsStore/clearStore', null, { root: true })
    dispatch('clearFilters')
    dispatch('toggleSelectAll', false)
    dispatch('resetUserSelectedFiltersAmount')
    dispatch('resetCurrentFilteredView')
  },
  setUserSelectedFiltersAmount: ({ commit }, filterAmount) => {
    commit('setUserSelectedFiltersAmount', filterAmount)
  },
  resetUserSelectedFiltersAmount: ({ commit }) => {
    commit('resetUserSelectedFiltersAmount')
  },
  removeUndefinedFilters ({ dispatch }, filters) {
    Object.keys(filters).forEach(key => {
      if (filters[key] === undefined) {
        delete filters[key]
      }
    })
    dispatch('setTransactionsFilters', { filters: filters })
  },

  fetchCurrentTransactionSelectedBudgetTagTypesTags: async (
    { commit },
    tagTypes
  ) => {
    try {
      const response = await companyApi.getTagTypes(tagTypes)
      commit('setCurrentTransactionSelectedBudgetTagTypes', response.data)
    } catch (error) {
      console.error(error)
    }
  },

  fetchTopBanner: async ({ getters, commit, dispatch }, filters) => {
    try {
      const response = await transactionsApi.getTopBanner(
        filters
      )
      if (response) {
        commit('setTopBanner', response.data)
      }
    } catch (error) {
      console.error(error)
      dispatch('SnackBars/addErrorHandler', {
        error: error,
        errorMessage: 'transactions_fetch_transactions_dashboard_error'
      },
        { root: true }
      )
    }
  },
  fetchTransactionDashboard: async ({ getters, commit, rootGetters, dispatch }, filters) => {
    if (getters.isCallingTransactionDashboard) return
    try {
      commit('setIsCallingTransactionDashboard', true)
      const transactionsFilters = filters || getters.filters
      const { data } = await transactionsApi.getTransactionsDashboard(transactionsFilters)
      commit('setTransactionDashboard', { ...data })
    } catch (error) {
      dispatch('SnackBars/addErrorHandler', {
        error: error,
        errorMessage: 'transactions_fetch_transactions_dashboard_error'
      }, { root: true })
    } finally {
      commit('setIsCallingTransactionDashboard', false)
    }
  },
  fetchTransactionsWithoutFiltersDashboard: async ({ getters, commit, rootGetters, dispatch }, filters) => {
    if (getters.isCallingTransactionDashboardWithoutFilters) return
    // No need to fetch data if bar is not shown
    if (!getters.transactionReviewBarIsShown) return
    if (!getters.transactionMissingInfoBarIsShown) return
    try {
      commit('setIsCallingTransactionsDashboardWithoutFilters', true)
      const { data } = await transactionsApi.getTransactionsDashboard(filters)
      commit('setTransactionsWithoutFiltersDashboard', { ...data })
    } catch (error) {
      dispatch('SnackBars/addErrorHandler', {
        error: error,
        errorMessage: 'transactions_fetch_transactions_dashboard_error'
      }, { root: true })
    } finally {
      commit('setIsCallingTransactionsDashboardWithoutFilters', false)
    }
  },

  toggleLockTransaction: async (
    { commit, dispatch },
    { transactionId, lock }
  ) => {
    if (!transactionId) return
    try {
      let response = {}
      if (lock) {
        response = await transactionsApi.putLockTransaction(transactionId)
        dispatch(
          'SnackBars/addSuccess',
          i18n.t('transactions_lock_transaction_success'),
          { root: true }
        )
      } else {
        response = await transactionsApi.putUnlockTransaction(transactionId)
        dispatch(
          'SnackBars/addSuccess',
          i18n.t('transactions_unlock_transaction_success'),
          { root: true }
        )
      }
      commit('updateTransaction', response.data)
      commit('setCurrentTransaction', response.data)
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        { error: error, errorMessage: 'transactions_lock_transaction_error' },
        { root: true }
      )
    }
  },
  toggleReviewTransaction: async (
    { commit, dispatch },
    { transactionId, review }
  ) => {
    if (!transactionId) return
    try {
      let response = {}
      if (review) {
        response = await transactionsApi.putReviewTransaction(transactionId)
        dispatch(
          'SnackBars/addSuccess',
          i18n.t('transactions_review_transaction_success'),
          { root: true }
        )
      } else {
        response = await transactionsApi.putUnreviewTransaction(transactionId)
        dispatch(
          'SnackBars/addSuccess',
          i18n.t('transactions_unreview_transaction_success'),
          { root: true }
        )
      }
      await dispatch('fetchTransactionDashboard')
      commit('updateTransaction', response.data)
      commit('setCurrentTransaction', response.data)
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        { error: error, errorMessage: 'transactions_review_transaction_error' },
        { root: true }
      )
    }
  },

  nextTransactionsPage: async ({ commit, dispatch, getters }) => {
    if (getters.isLoadingNextPageTransactions) return
    commit('incrementTransactionsCurrentPage')
    await dispatch('fetchTransactions')
  },
  toggleTableColumnVisibility: ({ commit, getters }, column) => {
    const columns = [...getters.tableColumns]
    columns.forEach(col => {
      if (col.key === column.key) {
        col.visible = !col.visible
      }
    })
    commit('setTableColumns', columns)
  },
  toggleExportTableColumnVisibility: ({ commit, getters }, column) => {
    const columns = [...getters.tableExportColumns]
    columns.forEach(col => {
      if (col.key === column.key) {
        col.visible = !col.visible
      }
    })
    commit('setTableExportColumns', columns)
  },

  toggleSelectedUser ({ commit, dispatch }, user) {
    if (!user) return
    commit('updateSelectedUsers', user)
    dispatch('setSelectedUsersBulkAction', false)
  },
  toggleSelectedTransaction ({ commit, dispatch }, transaction) {
    if (!transaction) return
    commit('updateSelectedTransactions', transaction)
    dispatch('setSelectedTransactionsBulkAction', false)
  },
  setAllTransactionsAsSelected: ({ commit, getters, rootGetters }, info) => {
    const transactions = getters.transactions
    const isUser = rootGetters['LoginStore/isUser']
    const isAdmin = rootGetters['LoginStore/isAdmin']
    const isBookKeeper = rootGetters['LoginStore/isBookKeeper']

    const transactionsToSelect = transactions.filter(el => {
      if (el.processing) {
        return false
      }
      if (info.isExportTable) {
        return true
      }
      if (el.reviewStatus.code === REVIEW_STATUS.DRAFT || el.receipt.accountingPeriod) {
        return false
      }
      if (isUser && el.budget.imOwner) {
        return true
      }

      if (isAdmin || isBookKeeper) {
        return true
      }
    })

    commit('setAllTransactionsAsSelected', transactionsToSelect)
  },
  setAllUsersAsSelected: ({ commit, getters, rootGetters }) => {
    commit('setAllUsersAsSelected', getters.users)
  },
  setSelectedTransactionsBulkAction: ({ commit, dispatch }, bulkActionValue) => {
    commit('setSelectedTransactionsBulkAction', bulkActionValue)
  },
  setSelectedUsersBulkAction: ({ commit, dispatch }, bulkActionValue) => {
    commit('setSelectedUsersBulkAction', bulkActionValue)
  },
  toggleSelectAll: ({ commit, dispatch }, info) => {
    commit('toggleSelectAll', info.selectAll)
    dispatch('setSelectedTransactionsBulkAction', false)
    if (!info.selectAll) {
      dispatch('clearSelectedTransactions')
    } else {
      dispatch('setAllTransactionsAsSelected', info)
    }
  },
  toggleSelectAllUsers: ({ commit, dispatch }, value) => {
    commit('toggleSelectAllUsers', value)
    dispatch('setSelectedUsersBulkAction', false)
    if (!value) {
      dispatch('clearSelectedUsers')
    } else {
      dispatch('setAllUsersAsSelected')
    }
  },
  clearSelectedTransactions: ({ commit }) => {
    commit('clearSelectedTransactions')
  },
  clearSelectedUsers: ({ commit }) => {
    commit('clearSelectedUsers')
  },

  /* ---- */
  /* --- FUNNEL ACTIONS  ---- */
  setTransactionReviewStatus: async (
    { commit, dispatch },
    { transactionId,
      reviewStatus }
  ) => {
    if (!transactionId || !reviewStatus) {
      return
    }
    try {
      const { data } = await transactionsApi.putChangeReviewStatus(
        transactionId, reviewStatus)

      commit('updateTransaction', data)
      commit('setCurrentTransaction', data)
      dispatch('fetchTransactionDashboard')
      dispatch(
        'SnackBars/addSuccess',
        i18n.t('transactions_change_funnel_status_success'),
        { root: true }
      )
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        {
          error: error,
          errorMessage: 'transactions_change_review_status_error'
        },
        { root: true }
      )
    }
  },
  reviewSelectedUsers: async ({ dispatch, commit, getters, rootGetters }, reviewInformation) => {
    try {
      let transactions = {
        transactionIds: [],
        ...reviewInformation
      }

      let bulkActionFilters = getters.filters
      Object.keys(bulkActionFilters).forEach(key => {
        if (key.includes('order') || bulkActionFilters[key] === undefined) {
          delete bulkActionFilters[key]
        }
      })

      let users = getters.selectedUsers.map(el => el.user_id)
      bulkActionFilters = { ...bulkActionFilters, 'card.user.id[]': users }
      transactions.filterQueryString = serialize(bulkActionFilters)
      await transactionsApi.postReviewSelectedTransactions(transactions)

      dispatch(
        'SnackBars/addSuccess',
        i18n.t('transactions_review_selected_users_success'),
        { root: true }
      )

      dispatch('clearSelectedUsers')
      dispatch('toggleSelectAll', false)
    } catch (error) {
      console.error(error)
      dispatch(
        'SnackBars/addErrorHandler',
        {
          error: error,
          errorMessage: 'transactions_review_selected_users_error'
        },
        { root: true }
      )
    }
  },

  unreviewSelectedUsers: async ({ dispatch, commit, getters }, reviewInformation) => {
    try {
      let selectedUsers = ''
      getters.selectedUsers.forEach((item, index) => {
        selectedUsers += (index + 1) !== getters.selectedUsers.length ? `card.user.id[]=${item.user_id}&` : `card.user.id[]=${item.user_id}`
      })
      let transactions = {
        transactionIds: [],
        ...reviewInformation,
        filterQueryString: selectedUsers
      }
      await transactionsApi.postUnreviewSelectedTransactionsBulk(transactions)
      dispatch(
        'SnackBars/addSuccess',
        i18n.t('transactions_unreview_selected_users_success'),
        { root: true }
      )

      dispatch('clearSelectedUsers')
      dispatch('toggleSelectAll', false)
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        {
          error: error,
          errorMessage: 'transactions_unreview_selected_users_error'
        },
        { root: true }
      )
    }
  },
  /* - Bulk and non bulk actions  */
  reviewSelectedTransactions: async ({ dispatch, commit, getters, rootGetters }, reviewInformation) => {
    try {
      const selectedTransactions = [...getters.selectedTransactions]
      let transactions = {
        transactionIds: [],
        ...reviewInformation
      }
      const loggedUser = rootGetters['UsersStore/userLogged']
      // const currentTransactionId = getters.currentTransaction && getters.currentTransaction.id ? getters.currentTransaction.id : false
      const canReviewTransaction = rootGetters['LoginStore/isAdmin'] || rootGetters['LoginStore/isBookKeeper'] || (rootGetters['LoginStore/isUser'] && (loggedUser.isOwnerOfAnyBudget || loggedUser.isReviewer))
      // Gets the ID of those transactions that can pass to reviewed

      // Recuerda : Gasto PErsonal => reviewStatus =APPROVED isPersonalExpense = true
      // Recuerda : Review => reviewStatus =APPROVED isPersonalExpense = false
      // const allowedToReviewStatuses = [REVIEW_STATUS.AWAITING_REVIEW, REVIEW_STATUS.CANCELLED, REVIEW_STATUS.APPROVED, REVIEW_STATUS.OFFICE_FLOW_REVISION]
      transactions.transactionIds.push(
        ...selectedTransactions.map(el => {
          if (!el.processing) {
            if (el.lockedAt === null) {
              if (el.reviewStatus.code !== REVIEW_STATUS.APPROVED) {
                if (el.reviewUserTasks.findIndex(el => el.canReviewNextStep && el.pending && el.user.id === loggedUser.id) > -1) {
                  return el.id
                } else {
                  if (el.reviewStatus.code === REVIEW_STATUS.CANCELLED && canReviewTransaction) {
                    return el.id
                  }
                }
              }
            }
          }
        }).filter(el => !isNaN(el))
      )
      if (getters.selectedTransactionsBulkAction) {
        let bulkActionFilters = getters.filters
        Object.keys(bulkActionFilters).forEach(key => {
          if (key.includes('order') || bulkActionFilters[key] === undefined) {
            delete bulkActionFilters[key]
          }
        })
        transactions.filterQueryString = serialize(bulkActionFilters)
      }

      let response = {}
      response = await transactionsApi.postReviewSelectedTransactions(
        transactions
      )

      const { data } = response
      data.transactionIdsToProcess.forEach(el => {
        commit('markTransactionAsProcessing', el)
      })
      dispatch(
        'SnackBars/addSuccess',
        i18n.t('transactions_review_selected_transactions_success'),
        { root: true }
      )

      dispatch('clearSelectedTransactions')
      dispatch('toggleSelectAll', false)
      /// Pillar las transacciones que no se han revisado
      dispatch('fetchTransactionDashboard')
    } catch (error) {
      console.error(error)
      dispatch(
        'SnackBars/addErrorHandler',
        {
          error: error,
          errorMessage: 'transactions_review_selected_transactions_error'
        },
        { root: true }
      )
    }
  },

  unreviewSelectedTransactions: async ({ dispatch, commit, getters }, reviewInformation) => {
    try {
      const selectedTransactions = [...getters.selectedTransactions]
      const transactions = {
        transactionIds: [],
        ...reviewInformation
      }

      // Gets the ID of those transactions that can pass to reviewed

      transactions.transactionIds.push(
        ...selectedTransactions.map(el => {
          if (el.reviewStatus.code === REVIEW_STATUS.APPROVED && !el.lockedAt && !el.processing) {
            return el.id
          }
        }).filter(el => !isNaN(el))
      )
      if (getters.selectedTransactionsBulkAction) {
        let bulkActionFilters = getters.filters
        Object.keys(bulkActionFilters).forEach(key => {
          if (key.includes('order') || bulkActionFilters[key] === undefined) {
            delete bulkActionFilters[key]
          }
        })
        transactions.filterQueryString = serialize(bulkActionFilters)
      }

      let response = {}
      response = await transactionsApi.postUnreviewSelectedTransactions(transactions)
      const { data } = response
      data.transactionIdsToProcess.forEach(el => {
        commit('markTransactionAsProcessing', el)
      })

      dispatch(
        'SnackBars/addSuccess',
        i18n.t('transactions_unreview_selected_transactions_success'),
        { root: true }
      )

      dispatch('fetchTransactionDashboard')
      dispatch('clearSelectedTransactions')
      dispatch('toggleSelectAll', false)
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        {
          error: error,
          errorMessage: 'transactions_unreview_selected_transactions_error'
        },
        { root: true }
      )
    }
  },
  accountSelectedTransactions: async ({ dispatch, commit, getters }) => {
    try {
      const selectedTransactions = [...getters.selectedTransactions]
      const transactions = {
        transactionIds: []
      }

      // Gets the ID of those transactions that can pass to reviewed

      transactions.transactionIds.push(
        ...selectedTransactions.map(el => {
          if ((el.reviewStatus.code === REVIEW_STATUS.APPROVED || el.reviewStatus.code === REVIEW_STATUS.CANCELLED) && !el.processing) {
            return el.id
          }
        }).filter(el => !isNaN(el))
      )
      if (getters.selectedTransactionsBulkAction) {
        let bulkActionFilters = getters.filters
        Object.keys(bulkActionFilters).forEach(key => {
          if (key.includes('order') || bulkActionFilters[key] === undefined) {
            delete bulkActionFilters[key]
          }
        })
        transactions.filterQueryString = serialize(bulkActionFilters)
      }

      let response = {}
      response = await transactionsApi.postAccountSelectedTransactions(transactions)
      const { data } = response
      data.transactionIdsToProcess.forEach(el => {
        commit('markTransactionAsProcessing', el)
      })

      dispatch(
        'SnackBars/addSuccess',
        i18n.t('transactions_account_selected_transactions_success'),
        { root: true }
      )

      dispatch('fetchTransactionDashboard')
      dispatch('clearSelectedTransactions')
      dispatch('toggleSelectAll', false)
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        {
          error: error,
          errorMessage: 'transactions_account_selected_transactions_error'
        },
        { root: true }
      )
    }
  },
  toggleLockSelectedTransactions: async ({ dispatch, commit, getters }, lockTransactions) => {
    try {
      const selectedTransactions = [...getters.selectedTransactions]
      const transactions = {
        transactionIds: []
      }
      transactions.transactionIds.push(
        ...selectedTransactions.map(el => {
          if (!el.processing) {
            return el.id
          }
        })
      )
      let transactionsData = []
      if (getters.selectedTransactionsBulkAction) {
        let bulkActionFilters = getters.filters
        Object.keys(bulkActionFilters).forEach(key => {
          if (key.includes('order') || bulkActionFilters[key] === undefined) {
            delete bulkActionFilters[key]
          }
        })
        transactions.filterQueryString = serialize(bulkActionFilters)
      }

      let response = {}
      if (lockTransactions) {
        response = await transactionsApi.postLockSelectedTransactions(
          transactions
        )
      } else {
        response = await transactionsApi.postUnlockSelectedTransactions(
          transactions
        )
      }

      const { data } = response
      transactionsData = [...data.transactionIdsToProcess]
      transactionsData.forEach(el => {
        commit('markTransactionAsProcessing', el)
      })

      dispatch(
        'SnackBars/addSuccess',
        i18n.t('transactions_unreview_selected_transactions_success'),
        { root: true }
      )

      dispatch('fetchTransactionDashboard')
      dispatch('clearSelectedTransactions')
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        {
          error: error,
          errorMessage: 'transactions_unreview_selected_transactions_error'
        },
        { root: true }
      )
    }
  },
  rejectSelectedTransactions: async ({ dispatch, commit, getters, rootGetters }, reviewInformation) => {
    try {
      const selectedTransactions = [...getters.selectedTransactions]
      const transactions = {
        transactionIds: [],
        rejectedReason: reviewInformation.rejectedReason
      }
      const loggedUser = rootGetters['UsersStore/userLogged']

      const canReviewTransaction = rootGetters['LoginStore/isAdmin'] || rootGetters['LoginStore/isBookKeeper'] || (rootGetters['LoginStore/isUser'] && (loggedUser.isOwnerOfAnyBudget || loggedUser.isReviewer))

      transactions.transactionIds.push(
        ...selectedTransactions.map(el => {
          if (el.lockedAt === null && !el.processing) {
            if (el.reviewStatus.code !== REVIEW_STATUS.CANCELLED) {
              if (el.reviewUserTasks.findIndex(el => el.canReviewNextStep && el.pending && el.user.id === loggedUser.id) > -1) {
                return el.id
              } else {
                if (el.reviewStatus.code === REVIEW_STATUS.APPROVED && canReviewTransaction) {
                  return el.id
                }
              }
            }
          }
        })
      )
      if (getters.selectedTransactionsBulkAction) {
        let bulkActionFilters = getters.filters
        Object.keys(bulkActionFilters).forEach(key => {
          if (key.includes('order') || bulkActionFilters[key] === undefined) {
            delete bulkActionFilters[key]
          }
        })
        transactions.filterQueryString = serialize(bulkActionFilters)
      }
      let response = {}
      response = await transactionsApi.postRejectSelectedTransactions(
        transactions
      )

      const { data } = response
      data.transactionIdsToProcess.forEach(el => {
        commit('markTransactionAsProcessing', el)
      })
      dispatch(
        'SnackBars/addSuccess',
        i18n.t('transactions_reject_selected_transactions_success'),
        { root: true }
      )

      dispatch('fetchTransactionDashboard')
      dispatch('clearSelectedTransactions')
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        {
          error: error,
          errorMessage: 'transactions_reject_selected_transactions_error'
        },
        { root: true }
      )
    }
  },

  // Internal, only for bulk actions to be used
  // IMPORTANTE! No borrar de momento, aunque se haya quitado el array de errores
  bulkActionErrorHandler: ({ dispatch, getters }, info) => {
    if (info.errors.length === 0 || typeof info.errors === 'undefined') return

    dispatch('SnackBars/addWarning', i18n.t('transactions_bulk_action_warning_errors'), { root: true })
    const noContextErrorList = ['LOCKED_TRANSACTION', 'REVIEW_STATUS_NOT_ALLOWED', 'USER_CAN_NOT_CHANGE_REVIEW_STATUS']
    let filters = { ...getters.filters }
    const invalidGoalLimitBudgetErrors = info.errors.filter(el => el.error === 'INVALID_GOAL_LIMIT_BUDGET')
    const noContextErrors = info.errors.filter(el => noContextErrorList.includes(el.error))
    noContextErrors.forEach(el => {
      if (el.error === 'LOCKED_TRANSACTION') {
        filters['exists[lockedAt]'] = true
      }
      if (el.error === 'REVIEW_STATUS_NOT_ALLOWED') {
        filters['exists[reviewedAt]'] = false
      }

      dispatch('SnackBars/addWarning', i18n.t('transactions_bulk_action_no_context_error'), { root: true })
    })

    if (invalidGoalLimitBudgetErrors.length > 0) {
      let errorList = `<ul class="Fuell-List--snackbar">`
      invalidGoalLimitBudgetErrors.forEach(el => {
        errorList += `<li class="Fuell-List--item--snack-bar">${el.budgetName}</li>`
      })
      errorList += '</ul>'
      dispatch('SnackBars/addWarning', `${i18n.t('transactions_bulk_action_invalid_budget_goal_error')} ${errorList}`, { root: true })
    }
    dispatch('clearTransactions')
    if (!info.users) {
      dispatch('setTransactionsFilters', { filters: filters, force: true })
    }
  },
  /* -------- */
  /* Flexible Remuneration Transactions management */

  fetchFlexibleRemunerationTransactions: async (
    { commit, dispatch, getters },
    pagination = true
  ) => {
    try {
      const page = getters.currentPage
      const filters = Object.assign({}, getters.filters)
      const {
        data,
        headers
      } = await transactionsApi.getFlexibleRemunerationTransactions(
        page,
        pagination,
        filters
      )
      const lastPage = headers['pagination-last-page']
      commit('setTransactionsLastPage', lastPage)
      commit('setTransactions', data)
      commit(
        'setTransactionsTotalItems',
        Number.parseInt(headers['pagination-total-items'])
      )
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        { error: error, errorMessage: 'transactions_fetch_transactions_error' },
        { root: true }
      )
    }
  },
  setFlexibleRemunerationFilters: async (
    { commit, getters, dispatch },
    filters
  ) => {
    filters['order[date]'] = 'DESC'
    if (!isEqual(filters, getters.filters)) {
      commit('setTransactionsFilters', filters)
      await dispatch('fetchFlexibleRemunerationTransactions')
    }
  },
  nextFlexibleRemunerationTransactionsPage: ({ commit, dispatch, getters }) => {
    commit('incrementTransactionsCurrentPage')
    dispatch('fetchFlexibleRemunerationTransactions')
  },

  /* - EXPENSES Actions -- */
  setExpenses: ({ commit }, expensesValue) => {
    commit('setExpensesValue', expensesValue)
  },
  addExpensesReceipts: ({ commit, getters }, receipts) => {
    commit('setCurrentExpenseReceipts', receipts)
  },
  deleteExpenseReceipt: ({ commit }, receiptIndex) => {
    commit('removeCurrentExpenseReceipt', receiptIndex)
  },
  resetExpenseReceipts: ({ commit }) => {
    commit('resetExpenseReceipts')
  },
  ignoreTransactionWarning: async (
    { getters, commit, dispatch },
    warningId
  ) => {
    try {
      await transactionsApi.ignoreTransactionWarning(warningId)
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        {
          error: error,
          errorMessage: 'transactions_put_transaction_resource_error'
        },
        { root: true }
      )
    }
  },
  fetchVatTypes: async ({ commit, getters, dispatch }) => {
    try {
      let response
      response = await transactionsApi.getVatTypes()
      commit('setVatTypes', response.data)
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        { error: error, errorMessage: 'expenses_fetch_payment_types_error' },
        { root: true }
      )
    }
  },
  fetchPaymentMethods: async ({ commit, getters, dispatch }, filters) => {
    try {
      let response
      response = await transactionsApi.getAllPaymentMethods(0, false, filters)

      commit('setUserPaymentMethods', response.data)
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        { error: error, errorMessage: 'expenses_fetch_payment_types_error' },
        { root: true }
      )
    }
  },
  fetchOfficePaymentMethods: async ({ commit, getters, dispatch }, filters) => {
    try {
      let response
      response = await transactionsApi.getOfficePaymentMethods(0, false, filters)

      commit('setOfficePaymentMethods', response.data)
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        { error: error, errorMessage: 'expenses_fetch_payment_types_error' },
        { root: true }
      )
    }
  },
  setPaymentMethodsFilters: async ({ commit, dispatch }, filters) => {
    commit('setUserPaymentMethodsFilters', filters)
    await dispatch('fetchPaymentMethods')
  },

  getFilteredViews: ({ commit }) => {
    if ('quickFilters' in localStorage) {
      const quickFilters = JSON.parse(localStorage.getItem('quickFilters'))
      if (quickFilters.length > 0) {
        const lastQuickFilterId = quickFilters[quickFilters.length - 1].id
        commit('loadFilteredViews', quickFilters)
        commit('setFilteredViewBaseId', lastQuickFilterId)
        commit('incrementFilteredViewBaseId')
      }
    }
  },
  createFilteredView: ({ getters, commit, dispatch }, filteredView) => {
    const newFilteredView = {
      id: getters.filteredViewBaseId,
      ...filteredView
    }

    commit('addFilteredView', newFilteredView)
    commit('incrementFilteredViewBaseId')
    dispatch('setCurrentFilteredView', newFilteredView)
  },
  editFilteredView: ({ commit }, newFilters) => {
    commit('editFilteredView', newFilters)
  },
  removeFilteredView: ({ commit, dispatch }, filteredViewId) => {
    commit('removeFilteredView', filteredViewId)
  },
  setCurrentFilteredView: ({ dispatch, commit, getters }, filteredView) => {
    commit('_removeAccountableFilters')
    const { filters } = filteredView

    dispatch('addTransactionsFilters', filters)
    commit('setCurrentFilteredView', filteredView)
  },
  resetCurrentFilteredView: ({ commit }) => {
    commit('setCurrentFilteredView', null)
  },
  /* Other actions */
  setReceiptModalIsOpen: ({ commit }, value) => {
    commit('setReceiptModalIsOpen', value)
  },
  toggleTransactionReviewBarShown: ({ commit }, value) => {
    commit('setTransactionReviewBarIsShown', value)
  },
  toggleTransactionMissingInfoBarShown: ({ commit }, value) => {
    commit('setTransactionMissingInfoBarIsShown', value)
  },
  setLoadingTransactions: ({ commit }, value) => {
    commit('setLoadingTransactions', value)
  },
  clearTransactions: ({ commit }) => {
    commit('clearTransactions')
  },
  clearCurrentTransaction: ({ commit }) => {
    commit('clearCurrentTransaction')
  },
  clearFilters: ({ commit }) => {
    commit('clearFilters')
  },
  /* --- */
  clearStore: ({ commit }) => {
    commit('clearStoreData')
  }
}
